import { Contract } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';

const ContractTemplatesLists = () => {
  const { values } = useFormikContext<IContractTemplateForm>();

  if (!values.sideMenu?.customTemplate) {
    return null;
  }

  const type = values.sideMenu.customTemplate.type;

  if (type === TEMPLATE_TYPE.agreement) {
    return <Contract.SideMenu.TemplatesList.Templates.Agreement />;
  }

  if (type === TEMPLATE_TYPE.digitalDistribution) {
    return <Contract.SideMenu.TemplatesList.Templates.DigitalDistribution />;
  }
  if (type === TEMPLATE_TYPE.physicalDistribution) {
    return <Contract.SideMenu.TemplatesList.Templates.PhysicalDistribution />;
  }

  if (type === TEMPLATE_TYPE.merchDistribution) {
    return <Contract.SideMenu.TemplatesList.Templates.MerchDistribution />;
  }
  if (type === TEMPLATE_TYPE.channelDistribution) {
    return <Contract.SideMenu.TemplatesList.Templates.ChannelDistribution />;
  }

  if (type === TEMPLATE_TYPE.section) {
    return <Contract.SideMenu.TemplatesList.Templates.Section />;
  }
  if (type === TEMPLATE_TYPE.paragraphSection) {
    return <Contract.SideMenu.TemplatesList.Templates.ParagraphSection />;
  }
  if (type === TEMPLATE_TYPE.contract) {
    return <Contract.SideMenu.TemplatesList.Templates.ContractTemplate />;
  }

  return null;
};

export default ContractTemplatesLists;
